import { all, takeEvery, put, call } from "redux-saga/effects";
import { push } from "connected-react-router";
import * as gaming from "./services";
import { actions } from "./reducers";

export function* REQUEST_TOKEN({ payload }) {
  const tokenRes = yield call(gaming.getToken, payload);
  yield put({
    type: "gaming/RECEIVE_TOKEN",
    payload: tokenRes,
  });
  yield put({
    type: "global/RECEIVE_SESSION_DETAILS",
    payload: tokenRes,
  });

  if (tokenRes.error) {
    if (tokenRes.type === "WEB") {
      yield put(push("/dashboard"));
    } else {
      yield put(push("/not-found"));
    }
  }
}

export function* REQUEST_PRODUCTS({ payload }) {
  yield put({
    type: "gaming/SET_LOADING",
    payload: true,
  });
  const { token, subcategory } = payload;
  const productsRes = yield call(gaming.getProducts, token, subcategory);
  if (productsRes) {
    yield put({
      type: "gaming/SET_LOADING",
      payload: false,
    });
  }
  yield put({
    type: "gaming/RECEIVE_PRODUCTS",
    payload: productsRes,
  });
}

export function* REQUEST_BUY_GAME({ payload }) {
  const reqPayload = {
    sku: payload.product,
    recipientMobile: payload.mobileNumber,
    sessionId: payload.sessionId,
    userId: payload.userId,
    category: payload.category,
  };
  const { token } = payload;
  const res = yield call(gaming.buyGame, reqPayload, token);
  const resPayload = {
    mobileNumber: payload.mobileNumber,
    product: payload.product,
    amount: payload.amount,
  };

  if (res.error) {
    yield put({
      type: "global/RECEIVE_TRANSACTION_OUTPUT",
      payload: { ...res, result: res.error },
    });
    yield put({
      type: "gaming/RECEIVE_BUY_GAME",
      payload: { ...resPayload, result: res.error },
    });
    yield put(push("/result"));
  } else {
    yield put({
      type: "global/RECEIVE_TRANSACTION_OUTPUT",
      payload: { ...res, result: "success" },
    });
    yield put({
      type: "wifi/RECEIVE_BUY_GAME",
      payload: { ...resPayload, result: "success" },
    });
    if (payload.sessionType === "BOT") {
      yield put(push("/result"));
    }
  }
}

export function* REQUEST_TRANSACTIONS({ payload }) {
  yield put({
    type: "gaming/SET_LOADING",
    payload: true,
  });
  const { limit, token } = payload;
  const transactionsRes = yield call(gaming.getTransactions, token, limit);
  if (transactionsRes) {
    yield put({
      type: "gaming/SET_LOADING",
      payload: false,
    });
  }
  const transactions = transactionsRes.map((transactions) => {
    return {
      status: transactions.status,
      time: transactions.updatedAt,
      amount: transactions.totalPrice,
      name: transactions.items[0].productSku,
      reference: transactions.referenceId,
    };
  });
  yield put({
    type: "gaming/RECEIVE_TRANSACTIONS",
    payload: transactions,
  });
}

export default function* rootSaga() {
  yield all([takeEvery(actions.REQUEST_TOKEN, REQUEST_TOKEN)]);
  yield all([takeEvery(actions.REQUEST_PRODUCTS, REQUEST_PRODUCTS)]);
  yield all([takeEvery(actions.REQUEST_BUY_GAME, REQUEST_BUY_GAME)]);
  yield all([takeEvery(actions.REQUEST_TRANSACTIONS, REQUEST_TRANSACTIONS)]);
}
